import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { VinconexLogo } from "@/components/VinconexMark";

export default function ScanRedirect() {
  const { code } = useParams();

  useEffect(() => {
    const key = `vx_scan_${code}`;
    let repeat = false;
    try {
      repeat = !!localStorage.getItem(key);
      localStorage.setItem(key, "1");
    } catch (e) {
      repeat = false;
    }
    const device = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? "mobile" : "desktop";
    api.post(`/public/scan/${code}`, { repeat, device })
      .then(({ data }) => window.location.replace(data.url))
      .catch(() => window.location.replace("/"));
  }, [code]);

  return (
    <div className="min-h-screen bg-[#05070C] text-white flex flex-col items-center justify-center gap-4" data-testid="scan-redirect">
      <VinconexLogo variant="wordmark" className="h-6 w-auto opacity-90" to={null} />
      <p className="text-sm text-slate-400 font-mono-tech uppercase tracking-widest">One second…</p>
    </div>
  );
}
